import React from "react";
import Styles from "./Terms.module.css";
import { useNavigate } from "react-router-dom";
import realmeimg from "../../assets/Realmeunit.png";
import userdummy from "../../assets/userselfie.jpg";
import fklogo from "../../assets/fklogo.png";
import logo from "../../assets/Swayambhu.png";
import women from "../../assets/landing.jpg";
import logonew from "../../assets/logo.png";

const Terms = () => {
  const navigation = useNavigate();

  const tandchandler = () => {
    // console.log("tandc")
    navigation("/home");
  };
  const disagreehandler = () => {
    console.log("disagreed");
  };
  const agreehandler = () => {};
  return (
    <div className={`${Styles.terms_main}`}>
      <div className={`${Styles.terms_card}`}>
        <img
          src={logonew}
          alt="Logo"
          className="w-56 sm:w-68 md:w-72 lg:w-[600px] xl:w-96"
        />{" "}
        {/* <h4 className={`${Styles.presenttitle}`}>presents</h4> */}
        {/* <h2 className={`${Styles.indiaketitle}`}>Face Finder AI</h2> */}
        {/* <div className={`${Styles.terms_content}`}> */}
        {/* <h2>Terms and Conditions</h2> */}
        {/* </div> */}
        {/* <div className={`${Styles.img_blur}`}>
          <img
            // src="https://influencerhai.com/wp-content/uploads/2022/12/harsh-punjabi-tech-influencer.jpg"
            src={women}
            alt=""
            className={`${Styles.img}`}
          />
        </div> */}
        <button
          onClick={tandchandler}
          className="
    mt-8
    px-6 py-3
    bg-gradient-to-r from-[#0077b6] to-[#00b4d8]
    text-white text-base sm:text-lg md:text-xl lg:text-2xl
    font-semibold rounded-full
    shadow-[0_4px_10px_rgba(0,119,182,0.3)]
    transition-all duration-300 ease-in-out
    hover:shadow-[0_6px_18px_rgba(0,119,182,0.5)]
    hover:scale-105 active:scale-95
    w-4/5 sm:w-3/5 md:w-2/5 lg:w-1/3 xl:w-1/4
    h-12 sm:h-14 md:h-16
  "
        >
          Get Your Photos
        </button>
        <p className={Styles.notice}>
          Your privacy is important to us.
          <br /> We do not store any facial recognition data.
        </p>
      </div>
    </div>
  );
};

export default Terms;
